import React, {useState} from "react";
import EditCustomer from "../../../../../entities/DashboardPage/AccountingModule/Customer/EditCustomer";
import AuthService from "../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const EditCustomerPage = () => {
  // const [data,setData] = useState([]);
  // console.log(data, "suppdata")
  const {showAlert} = useAlert();
  const {state} = useLocation();
  const {item} = state||{};
  const navigate = useNavigate();



  const [loading,setLoading] = useState(false);


  const handleEditCustomer = async (data,mobile,cCode,user) => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.updateCustomer(data, item?._id,user,mobile,cCode);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message,"success");
        navigate("/dashboard/customer")


      } else {
        
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message,"error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);

      showAlert(error,"error");
    }
  };

  return (
    <EditCustomer handleEditCustomer={handleEditCustomer} loading={loading} item={item}/>
  )

}

export default EditCustomerPage;
